import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router';

import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';
import { ApplicationHeader } from '@rio-cloud/rio-uikit/ApplicationHeader';
import IframeResizer from 'iframe-resizer-react';

import { config } from '../../../config';
import { ServiceInfo } from './ServiceInfo';
import {
    COMPOUND_MANAGEMENT_ROUTE,
    OOB_INSPECTOR_ROUTE,
    SERVICE_ORDER_ROUTE,
    SERVICE_PROVIDER_ACTIVATION_ROUTE,
    TRANSPORT_ORDER_ROUTE,
    WELCOME_ROUTE,
} from '../routes/routes';
import classNames from 'classnames';
import { FeatureToggles, useFeatureToggle } from '../../../configuration/featureToggle/toggleHook';

type AppHeaderProps = {
    isActive: boolean;
    isCompoundAccessRolloutEnabled?: boolean;
    isCompoundManagementAvailable?: boolean;
};

export const AppHeader = (props: AppHeaderProps) => {
    const isLspAdministrationEnabled = useFeatureToggle(FeatureToggles.LSP_ADMINISTRATION, false).value;
    const isCompoundManagementEnabled = useFeatureToggle(FeatureToggles.COMPOUND_MANAGEMENT, false).value;
    const isOobInspectorEnabled = useFeatureToggle(FeatureToggles.OOB_INSPECTOR, false).value;
    const featureLinkClass = classNames({ disabled: !props.isActive });
    const navItems = [
        {
            key: 'welcome',
            route: (
                <NavLink to={WELCOME_ROUTE}>
                    <FormattedMessage id="outboundPortal.header.navigation.welcome" />
                </NavLink>
            ),
        },
        {
            key: 'transport-orders',
            route: (
                <NavLink to={TRANSPORT_ORDER_ROUTE} className={featureLinkClass}>
                    <FormattedMessage id="outboundPortal.header.navigation.transportOrders" />
                </NavLink>
            ),
        },
        {
            key: 'service-orders',
            route: (
                <NavLink to={SERVICE_ORDER_ROUTE} className={featureLinkClass}>
                    <FormattedMessage id="outboundPortal.header.navigation.serviceOrders" />
                </NavLink>
            ),
        },
    ];

    if (props.isCompoundAccessRolloutEnabled ? props.isCompoundManagementAvailable : isCompoundManagementEnabled) {
        navItems.push({
            key: 'compound-management',
            route: (
                <NavLink to={COMPOUND_MANAGEMENT_ROUTE} className={featureLinkClass}>
                    <FormattedMessage id="outboundPortal.header.navigation.compoundManagement" />
                </NavLink>
            ),
        });
    }

    if (isLspAdministrationEnabled) {
        navItems.push({
            key: 'service-provider-activation',
            route: (
                <NavLink to={SERVICE_PROVIDER_ACTIVATION_ROUTE} className={featureLinkClass}>
                    <FormattedMessage id="outboundPortal.header.navigation.serviceProviderActivation" />
                </NavLink>
            ),
        });
    }

    if (isOobInspectorEnabled) {
        navItems.push({
            key: 'oob-inspector',
            route: (
                <NavLink to={OOB_INSPECTOR_ROUTE} className={featureLinkClass}>
                    <FormattedMessage id="outboundPortal.header.navigation.oobInspector" />
                </NavLink>
            ),
        });
    }

    const environment = import.meta.env.MODE === 'production' ? 'production' : 'local';

    const homeLink = <a href={config.homeRoute !== undefined ? config.homeRoute : ''} />;

    return (
        <ApplicationHeader
            label={config.application.name}
            appNavigator={<IframeResizer className="iFrameResizer" src={config.backend.MENU_SERVICE} />}
            homeRoute={homeLink}
            navItems={navItems}
            actionBarItems={[
                <ServiceInfo key="service-info" />,
                <DefaultUserMenu key="user-menu" environment={environment} />,
            ]}
        />
    );
};
